<script setup>
defineProps({
  link: { type: String },
  target: { type: String, default: '_blank' },
  label: { type: String }
})

const freeWeekend = useFreeWeekend()

const recentFwTheme = computed(() => {
  if (!freeWeekend.data) return null

  const techTheme = useTechTheme().techThemeVariables[freeWeekend.data.tech]
  const lowestTheme = techTheme?.junior || techTheme?.intermediate

  return [lowestTheme.bgColorTransparent, lowestTheme.borderColor, lowestTheme.bgColorHover].join(' ')
})
</script>

<template>
  <NuxtLink
    :to="link"
    :target="target"
    class="flex items-center whitespace-nowrap">
    <span :class="[`free-weekend-button-raw ${recentFwTheme}`]">
      <div
        v-if="freeWeekend.activeFreeWeekendCert"
        class="size-2.5 animate-pulse rounded-full bg-danger" />
      {{ label }}
      <slot />
    </span>
  </NuxtLink>
</template>
